import { CM, Tction } from '@tkit/model';
import { TkitUtils as Utils } from '@tkit/types';
import { message } from 'antd';

import {
  APIS,
  ParamsvoteCommentVoteQuestionIdUsingGet,
  PageableResultCommentInfo,
  ParamsBodyvoteCommentUsingPost,
  CommentInfo
} from '@src/services';

export interface State {
  commentModel: CommentInfo[];
}

export const commentModelState: State = {
  commentModel: []
};

const model = CM({
  state: commentModelState,
  namespace: 'commentModel',
  reducers: {
    /**
     * @description 设置投票评论
     */
    setVoteComments: (state, action: Tction<CommentInfo[]>) => {
      return {
        ...state,
        commentModel: action.payload
      };
    },
    /**
     * @description 添加投票评论
     */
    addVoteComments: (state, action: Tction<CommentInfo>) => {
      const { commentModel } = state;

      return {
        ...state,
        commentModel: [action.payload, ...commentModel]
      };
    },
    /**
     * @description 设置删除评论的数据
     */
    voteRemoveComment: (state, action: Tction<number>) => {
      const { commentModel } = state;

      return {
        ...state,
        commentModel: commentModel.filter(item => item.id !== action.payload)
      };
    },
    /**
     * @description 设置点赞/取消点赞评论的数据
     */
    setVoteToggleThumb: (state, action: Tction<{ id: number; isThumb: boolean }>) => {
      const { id, isThumb } = action.payload;
      const { commentModel } = state;

      return {
        ...state,
        commentModel: commentModel.map(item => {
          if (item.id === id) {
            return {
              ...item,
              hasLiked: isThumb,
              thumbs: (item.thumbs || 0) + (isThumb ? 1 : -1)
            };
          } else {
            return item;
          }
        })
      };
    }
  },
  effects: {
    /**
     * 发布1级评论
     * @param param0
     * @param action
     */
    *addComment(
      { tCall, tPut },
      action: Tction<{
        params: ParamsBodyvoteCommentUsingPost;
        callback?: (res?: CommentInfo) => void;
      }>
    ): Iterator<{}, any, any> {
      const { params, callback } = action.payload;
      const res: Utils.GetROA<typeof APIS.VoteApi.voteCommentUsingPost> = yield tCall(
        APIS.VoteApi.voteCommentUsingPost,
        params
      );

      if (res.code === 0 && res.result) {
        yield tPut(model.actions.addVoteComments, res.result);
        callback && callback();
      } else {
        message.error(res.message);
      }
    },
    /**
     * @description 获取投票评论
     */
    *getVoteComments(
      { namespace, put, tPut, tCall },
      action: Tction<{
        params: ParamsvoteCommentVoteQuestionIdUsingGet;
      }>
    ): Iterator<{}, any, any> {
      const { params } = action.payload;
      const data: Utils.GetROA<typeof APIS.VoteApi.voteCommentVoteQuestionIdUsingGet> = yield tCall(
        APIS.VoteApi.voteCommentVoteQuestionIdUsingGet,
        params
      );

      if (data.code === 0 && data.result) {
        yield tPut(model.actions.setVoteComments, data.result);
      }
    },
    /**
     * 获取删除评论
     */
    *removeVoteComment(
      { tPut, tCall },
      action: Tction<{
        params: { id: number };
        callback?: () => void;
      }>
    ): Iterator<{}, any, any> {
      const { params, callback } = action.payload;
      const res: Utils.GetROA<typeof APIS.CommentApi.commentsIdUsingDelete> = yield tCall(
        APIS.CommentApi.commentsIdUsingDelete,
        params
      );

      if (res.code === 0) {
        yield tPut(model.actions.voteRemoveComment, params.id);
        callback && callback();
      }
    },
    /**
     * 点赞
     */
    *voteThumb(
      { tPut, tCall },
      action: Tction<{
        params: { id: number };
        callback?: () => void;
      }>
    ): Iterator<{}, any, any> {
      const { params, callback } = action.payload;
      const res: Utils.GetROA<typeof APIS.CommentApi.commentsThumbUpIdUsingPost> = yield tCall(
        APIS.CommentApi.commentsThumbUpIdUsingPost,
        params
      );

      if (res.code === 0) {
        yield tPut(model.actions.setVoteToggleThumb, { id: params.id, isThumb: true });
        callback && callback();
      }
    },
    /**
     * 取消点赞
     */
    *voteCancelThumb(
      { tPut, tCall },
      action: Tction<{
        params: { id: number };
        callback?: () => void;
      }>
    ): Iterator<{}, any, any> {
      const { params, callback } = action.payload;
      const res: Utils.GetROA<typeof APIS.CommentApi.commentsThumbUpIdUsingDelete> = yield tCall(
        APIS.CommentApi.commentsThumbUpIdUsingDelete,
        params
      );

      if (res.code === 0) {
        yield tPut(model.actions.setVoteToggleThumb, { id: params.id, isThumb: false });
        callback && callback();
      }
    }
  }
});

/**
 * @description 全局Model commentModel 挂载到 redux 上
 */
export default model;
